import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import {
	FormControl,
	Grid,
	Button,
	Icon,
	FormHelperText,
} from '@mui/material';
import 'date-fns';
import history from '../../../../router/history';
import { constants } from '../../../../constants/Constants';
import BaseLayout from '../../../BaseLayout';
import { Campaign, User } from '@horasys/bellplus/common/types';
import { Client } from '@horasys/bellplus/common/types';
import AlertBox from 'views/Common/AlertBox';
//import { checkCampaignName } from '../../../../services/campaigns.service';
import { validateSchema } from 'validations/common';
import { campaignFormSchema } from './CampaignFormValidation';
import { checkCampaignName } from 'services/campaigns.service';
import { useAppDispatch } from 'Stores/Hooks/hooks';
import { UPDATE_CAMPAIGN_FORM, getAdvertisementsByClientIdAction, getCampaignAdvertisements } from 'Stores/Slices/campaignSlice';
import { CssTextField } from 'views/Common/CssTextField';
const PREFIX = 'CampaignForm';

const classes = {
    formElement: `${PREFIX}-formElement`,
    paperchildGrid: `${PREFIX}-paperchildGrid`,
    saveGrid: `${PREFIX}-saveGrid`
};

const StyledBaseLayout = styled(BaseLayout)((
    {
        theme
    }
) => ({
    [`& .${classes.formElement}`]: {
        marginTop: theme.spacing(3),
        minWidth: '100%',
    },

    [`& .${classes.paperchildGrid}`]: {
        // padding: theme.spacing(2),
        padding:'20px'
    },

    [`& .${classes.saveGrid}`]: {
        marginTop: theme.spacing(2),
    }
}));

interface Props {
	campaign: Campaign;
	handleNext: any;
	onSubmit: any;
	viewMode: boolean;
	handleBack: any;
	role: string;
}
const CampaignForm = (props: Props) => {
	const { handleNext, campaign } = props;
	const [usersList] = useState<any>([]);


	const [errorObj, setErrorObj] = useState<any>({});

	const [alertError] = useState({ message: '', open: false });
	const cancelClient = () => {
		history.back();
	};

	const userDtails = localStorage.getItem('userDetails');
	const parsedUserDetails = userDtails
		? JSON.parse(userDtails)
		: { data: { clientId: 1, id: 1, username: 'root' } };

	const dispatch = useAppDispatch();
	const client: Client = {} as Client;
	client.id = parsedUserDetails?.data.clientId;
	client.name = parsedUserDetails?.data?.username;

	useEffect(() => {
		dispatch(getCampaignAdvertisements());
	}, [dispatch]);

	const updateCampaignForm = async (partialCampaign: Partial<Campaign>, key?: any) => {
		dispatch(UPDATE_CAMPAIGN_FORM(partialCampaign));
	};

	const validateCampaignName = async (value: any) => {
		if (campaign.name)
			if (campaign.originalName.trim().localeCompare(campaign.name.trim()) === 0) {
				console.warn('both are equal');
				setErrorObj({});
				return Promise.resolve();
			}
		try {
			await checkCampaignName(value);
			return Promise.resolve({});
		} catch (error) {
			console.log('error', error);
			return Promise.reject(error);
		}
	};

	const handleCampaignForm = async (event: any) => {
		//const client: Client = {} as Client;

		switch (event.target.name) {
			case 'campaignName':
				updateCampaignForm({ client: client, name: event.target.value });
				//validateCampaignName(event.target.value);
				break;

			case 'clientId':
				if (event.target.value) {
					client.id = event.target.value.id;
					client.companyName = event.target.value.companyName;
					updateCampaignForm({ client: client }, 'clientId');
					dispatch(getAdvertisementsByClientIdAction(client.id));
				} else {
					client.id = 0;
					client.companyName = '';
					updateCampaignForm({ client: client }, 'clientId');
				}

				break;
			case 'userName': {
				const selectedUsers = usersList.filter((user: any) => {
					if (user.username === event.target.value) return true;
					else return false;
				});
				const salesPersonUserObj: User = {} as User;
				salesPersonUserObj.id = selectedUsers[0].id;
				salesPersonUserObj.username = event.target.value;
				updateCampaignForm({ salesPersonUser: salesPersonUserObj });
				break;
			}

			default:
				break;
		}
	};

	const handleSubmit = async (event: any) => {
		event.preventDefault();
		try {
			console.warn({
				clientId: campaign.client ? campaign.client.id : 0,
				campaignName: campaign.name,
			});
			await validateSchema(campaignFormSchema, {
				clientId: campaign.client ? campaign.client.id : 0,
				campaignName: campaign.name,
			});
			await validateCampaignName(campaign.name);
			console.warn(' i am here');
			setErrorObj({});
			handleNext();
		} catch (error) {
			console.warn('error from form, m here', error);

			setErrorObj(error);
		}
	};

	return (
        <StyledBaseLayout>
			<AlertBox
				message={alertError.message}
				shouldOpen={alertError.open}
				type="warning"
			/>
			<form onSubmit={handleSubmit} className={classes.paperchildGrid} noValidate style={{padding:'40px 20px'}}>
				<FormControl variant="outlined" className={classes.formElement} style={{width:'100%'}} >
					<CssTextField
						label="Campaign Name"
						name="campaignName"
						variant="outlined"
						required
						fullWidth
						autoComplete="off"
						value={campaign.name}
						onChange={handleCampaignForm}
					/>
					{errorObj.campaignName && (
						<FormHelperText error={true}>
							{errorObj.campaignName}
						</FormHelperText>
					)}
				</FormControl>
				<Grid
					container
					item
					direction="row"
					justifyContent="space-around"
					className={classes.saveGrid}
          style={{margin:'30px 0 -20px 0 '}}
          >
					<Grid item>
						<Button className={classes.formElement} onClick={cancelClient} style={{color:'#042630'}}>
							{constants.CANCEL}
						</Button>
					</Grid>
					<Grid item>
						<Button
							type="submit"
							className={classes.formElement}
							variant="contained"
							onSubmit={handleSubmit}
							color="primary"
							endIcon={<Icon>send</Icon>}
              style={{backgroundColor:'#042630'}}>
							Next
						</Button>
					</Grid>
				</Grid>
			</form>
		</StyledBaseLayout>
    );
};

export default CampaignForm;
